import {type ValidSubdomain, webEnvironmentFromHostname} from 'notability-services-common-universal'

export function makeURLFriendly(val: string) {
  return val.replace(/ /g, '-').toLowerCase()
}

export function deURLFriendly(val: string) {
  return val
    .split('-')
    .map((val) => (val[0]?.toUpperCase() ?? '') + val.substr(1))
    .join(' ')
}

export function getNonProductionServerNamespace(): ValidSubdomain | undefined {
  if (typeof window === 'undefined') {
    return undefined
  }
  const environment = webEnvironmentFromHostname(window.location.hostname)
  switch (environment.kind) {
    case 'staging':
      return 'staging'
    case 'berry':
      return environment.namespace
    default:
      return undefined
  }
}
